import { PATHS } from '../configs';
import { environment } from '../environments/environment';
import client from '../services/client';

import type { ChainStoreInvoice, SupportReceiptType } from '../types';

const ORDER_TYPE_INVOICE_ORDER = 'invoice_order';

const PAYMENT_ENDPOINT = `${environment.paymentApiEndpoint}//webview/credit_card/create_with_payment`;

type CreateCreditCardTransactionThroughMochiPayProps = {
  email: string;
  receipt: {
    name: string;
    phone: string;
    barcode?: string;
    type: SupportReceiptType;
    ubn?: string;
    donate?: string;
  };
  invoice: ChainStoreInvoice;
  merchantUid: string;
  creditCard: {
    number: string;
    exp: string;
    cvc: string;
  };
  callbackParams?: {
    serviceUid: string;
    captureMethod: string;
    amount: string;
    merchantUid: string;
  };
};

export const createCreditCardTransactionThroughMochiPay = async ({
  email,
  receipt,
  invoice,
  merchantUid,
  creditCard,
}: CreateCreditCardTransactionThroughMochiPayProps) => {
  const {
    data: {
      data: { id },
    },
  } = await client.createCreditCardTransactionSession({
    invoiceId: invoice.id,
    email,
    receipt,
  });

  const params = {
    serviceTransactionId: id,
  };

  const url = `${window.location.origin}${PATHS.INVOICES(invoice.id).AUTH.CREDIT_CARD}`;
  const callbackUrl = `${url}?${new URLSearchParams(params).toString()}`;

  fireEventWithForm({
    callbackUrl,
    creditCard,
    invoice,
    merchantUid,
  });
};

function fireEventWithForm({
  creditCard: { number: cardNumber, exp: cardExpireDate, cvc: cardCvc },
  invoice,
  merchantUid,
  callbackUrl,
}: {
  creditCard: {
    number: string;
    exp: string;
    cvc: string;
  };
  invoice: ChainStoreInvoice;
  merchantUid: string;
  callbackUrl: string;
}) {
  const form = document.createElement('form');
  form.method = 'post';
  form.action = PAYMENT_ENDPOINT;
  form.setAttribute('hidden', 'true');

  const inputGroup = [
    {
      name: 'pan',
      value: cardNumber.replace(/\s/g, ''),
    },
    {
      name: 'expire_date',
      value: cardExpireDate.replace(/\//g, ''),
    },
    {
      name: 'cvc',
      value: cardCvc,
    },
    {
      name: 'amount',
      value: invoice.amount,
    },
    {
      name: 'merchant_uid',
      value: merchantUid,
    },
    {
      name: 'order_type',
      value: ORDER_TYPE_INVOICE_ORDER,
    },

    {
      name: 'transaction_type',
      value: invoice.transaction_type,
    },
    {
      name: 'frontend_callback_url',
      value: callbackUrl,
    },
  ];

  inputGroup.forEach((data) => {
    if (!data.value) return;

    const inputElement = document.createElement('input');
    inputElement.value = data.value;
    inputElement.name = data.name;
    form.appendChild(inputElement);
  });

  document.body.appendChild(form);

  form.submit();
}
